export const SEGMENT_EVENTS = {
    CreateCoachAccount: {
        key: 'CreateCoachAccount',
        properties: ['formData', 'userType']
    },
    FeatureEngaged: {
        key: 'FeatureEngaged',
        properties: ['feature', 'location', 'userType']
    }
};
